import { Loader2 } from "lucide-react";
import { Fetcher, useNavigation } from "react-router-dom";
import { WithIcon } from "./with-icon";

interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
    onSubmitting?: React.ReactNode;
    onLoading?: React.ReactNode;
    fetcher?: Fetcher;
    icon?: boolean;
}

export function NavigationStatus({ children, onSubmitting, onLoading, fetcher, icon = true }: SidebarProps) {
    const { state } = useNavigation();
    if ((fetcher?.state || state) == "loading") {
        return icon ? (
            <WithIcon icon={Loader2} iconClassName="animate-spin">
                {onLoading ? onLoading : "Chargement..."}
            </WithIcon>
        ) : onLoading ? (
            onLoading
        ) : (
            "Chargement..."
        );
    }
    if ((fetcher?.state || state) == "submitting") {
        return icon ? (
            <WithIcon icon={Loader2} iconClassName="animate-spin">
                {onSubmitting ? onSubmitting : "Chargement..."}
            </WithIcon>
        ) : onSubmitting ? (
            onSubmitting
        ) : (
            "Chargement..."
        );
    }
    return children;
}
